import {
    PSMS_TAXID_HEALTH_SYSTEM_REQUEST,
    PSMS_TAXID_HEALTH_SYSTEM_SUCCESS,
    PSMS_TAXID_HEALTH_SYSTEM_FAILURE,
    PSMS_TAXID_HEALTH_SYSTEM_LOADING,
    PSMS_TAXID_EXTENDED_TIN_REQUEST,
    PSMS_TAXID_EXTENDED_TIN_SUCCESS,
    PSMS_TAXID_EXTENDED_TIN_FAILURE,
    PSMS_TAXID_EXTENDED_TIN_LOADING,
} from '../actionTypes';

// ── Health System Data (providerKey) ─────────────────────────────────────────

export const fetchHealthSystemData = () => ({
    type: PSMS_TAXID_HEALTH_SYSTEM_REQUEST,
});

export const fetchHealthSystemDataSuccess = (payload: any) => ({
    type: PSMS_TAXID_HEALTH_SYSTEM_SUCCESS,
    payload,
});

export const fetchHealthSystemDataFailure = (payload: any) => ({
    type: PSMS_TAXID_HEALTH_SYSTEM_FAILURE,
    payload,
});

export const fetchHealthSystemDataLoading = (payload: boolean) => ({
    type: PSMS_TAXID_HEALTH_SYSTEM_LOADING,
    payload,
});

// ── Extended TIN List ─────────────────────────────────────────────────────────

export const fetchExtendedTinList = () => ({
    type: PSMS_TAXID_EXTENDED_TIN_REQUEST,
});

export const fetchExtendedTinListSuccess = (payload: any) => ({
    type: PSMS_TAXID_EXTENDED_TIN_SUCCESS,
    payload,
});

export const fetchExtendedTinListFailure = (payload: any) => ({
    type: PSMS_TAXID_EXTENDED_TIN_FAILURE,
    payload,
});

export const fetchExtendedTinListLoading = (payload: boolean) => ({
    type: PSMS_TAXID_EXTENDED_TIN_LOADING,
    payload,
});
